import store from "@/store"
import { GiveawayType } from "@/store/types"
import { DefaultEventsMap } from "@socket.io/component-emitter"
import { Socket } from "socket.io-client"
import { GiveawayStatus } from "../enums"
import { bus } from "@/utils"

export class GiveawaySocketService {
  public store = store

  private onGiveawayCreated = this.giveawayCreated.bind(this)
  private onGiveawayUpdated = this.giveawayUpdated.bind(this)

  constructor(public socket: Socket<DefaultEventsMap, DefaultEventsMap>) {
    this.handleEvents()
  }

  handleEvents() {
    this.socket.on("giveaway:created", this.onGiveawayCreated)
    this.socket.on("giveaway:updated", this.onGiveawayUpdated)
  }

  destroy() {
    this.socket.off("giveaway:created", this.onGiveawayCreated)
    this.socket.off("giveaway:updated", this.onGiveawayUpdated)
  }

  giveawayCreated(giveaway: GiveawayType) {
    this.store.commit(`giveaways/ADD`, giveaway)
  }

  async giveawayUpdated() {
    // giveaway: Partial<GiveawayType>
    // this.store.commit(`giveaways/UPDATE`, giveaway)
    await this.store.dispatch("giveaways/getGiveaways", {
      status: GiveawayStatus.STARTED,
      game_slug: "all",
    })

    bus.emit("giveaway:updated", this.store.getters["giveaways/data"])
  }
}
